import { render, staticRenderFns } from "./listFiltroClientes.vue?vue&type=template&id=1ec52a09&"
import script from "./listFiltroClientes.vue?vue&type=script&lang=js&"
export * from "./listFiltroClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports